import { render, staticRenderFns } from "./SubwayStationsItem.vue?vue&type=template&id=0801518a&scoped=true&"
import script from "./SubwayStationsItem.vue?vue&type=script&lang=js&"
export * from "./SubwayStationsItem.vue?vue&type=script&lang=js&"
import style0 from "./SubwayStationsItem.vue?vue&type=style&index=0&id=0801518a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0801518a",
  null
  
)

export default component.exports